import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'accommodations_report',
    label: 'AccommodationsReport',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
